module.exports = new __parcel__URL__("pin_produit.1ecf0c46.png").toString();